import { Alert } from "@cmsgov/ds-medicare-gov";
import { PropsWithChildren } from "react";

interface SuccessAlertProps {
    heading: string
}
export const SuccessAlert = (props: PropsWithChildren<SuccessAlertProps>) => {
    return (
        <Alert
            variation="success"
            className="ds-u-margin-bottom--3 ds-u-margin-top--3"
            heading={props.heading}
        >
            <p className="ds-c-alert__text">
                { props.children }
            </p>
        </Alert>
    );
}